import { AccessToken } from '../../common/access-token';
import { CheckRequirementType } from './check-requirement-type.enum';
import { EmailSelectionStatus } from './email-selection-status.enum';
import { NomidioChannel } from './nomidio-channel';

export enum MfaMethod {
  Totp = 'TOTP',
  Email = 'EMAIL',
  Phone = 'PHONE',
}

export type ChallengeCriteria<T extends CheckRequirementType = any> = {
  /**
   * The challenge criteria type.
   */
  type: T;

  /**
   * The MFA ID. Present only on CheckRequirementType.EmailMfa.
   */
  mfa_id?: string;

  mfa_method?: MfaMethod;

  /**
   * The target email for MFA (may be obscured). Present only on CheckRequirementType.EmailMfa.
   */
  email?: string;
}

export interface ChallengeAcceptedResponse {
  id: string;
  status?: string;
  device_id?: string;
  access_token: AccessToken;
  criteria?: ChallengeCriteria[];
  enterprise_name: string;
  enterprise_id: string;
  expire_at: number;
  recovery_id?: string;
  user_id: string;
  email_selection?: EmailSelectionStatus;
  channel: NomidioChannel;
}
